/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/19
 * Time: 1:28 PM
 */
import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import * as config from '../../../const/config/config'
import icon from '../../../assets/img/google_map/placeholder.svg'
import {Tooltip} from "antd";
import Map_property from "./Properties";

const AnyReactComponent = ({text}) => <div
  style={{
    color: 'white',
    // background: 'grey',
    // padding: '15px 10px',
    display: 'inline-flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600'
  }}
>
  <Tooltip placement="topLeft" title={text}>
    <img src={icon} alt={"."}/>
  </Tooltip>
</div>;

class SimpleMap extends Component {

  render() {
    return (
      <div style={{height: '50vh', width: '100%'}}>
        <GoogleMapReact
          bootstrapURLKeys={{key: config.GOOGLE_LOCATION_KEY}}
          defaultCenter={{lat: this.props.latitude, lng: this.props.longitude}}
          defaultZoom={11}
          options={{
            scrollwheel: true,
            zoomControl: false,
            draggable: true,
            disableDefaultUI: true,
            styles: Map_property
          }}
        >
          <AnyReactComponent
            lat={this.props.latitude}
            lng={this.props.longitude}
            text={this.props.location}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
